import ModalContainer, {
  ModelContainerProps,
} from "../../../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

interface IProps extends ModelContainerProps {
  deviceName?: string;
}

const RemoveDeviceModal = (props: IProps) => {
  const { deviceName, onConfirm, ...rest } = props;

  return (
    <ModalContainer
      {...rest}
      title="Remove Device"
      confirmButtonText="Remove"
      confirmButtonVariant="red"
      size="modal-md"
      onConfirm={onConfirm}
    >
      <p className="text-light font-size-14 m-0">
        Are you sure you want to remove{" "}
        {deviceName ? <strong>{deviceName}</strong> : "this device"} ?
      </p>
    </ModalContainer>
  );
};

export default RemoveDeviceModal;
